import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

const Header: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <p className={s.title}>{t('labels.smsAutoReplySettings')}</p>
    </div>
  );
};

export default Header;
